import React from "react";
import { Button } from "antd";
import styles from "./index.module.scss";
import classNames from "classnames";

interface ReviewDrawerFooterProps {
    score: number;
    goPrev?: () => void;
    goNext?: () => void;
}

export default function ReviewDrawerFooter({
    score,
    goPrev,
    goNext
}: ReviewDrawerFooterProps) {
    return (
        <div className={styles.root}>
            <div className={styles.score}>总得分 {score}</div>

            <Button
                type="primary"
                className={styles.button}
                onClick={goPrev}
                disabled={!goPrev}>
                上一份
            </Button>

            <Button
                type="primary"
                className={classNames(styles.button, styles.next)}
                onClick={goNext}
                disabled={!goNext}>
                下一份
            </Button>
        </div>
    );
}
